import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import map from 'lodash/map';
import first from 'lodash/first';
import moment from 'moment';
import {
  PageHeading,
  SubHeading,
  SectionHeading,
  SubsectionHeading
} from 'web-ui-components/lib/typography/headings';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { BrandedPanel } from 'web-ui-components/lib/layout/content';
import { ActionButton } from 'web-ui-components/lib/actions/buttons';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { Content } from '../../infrastructure/content';
import { DATE_FORMAT } from '../../utils/constants';
import { getResumeCases } from '../../infrastructure/cases/selectors';
import { setResumeConfigParam } from '../../infrastructure/config/actions';
import { redirectToPage } from '../../store/dataCapture';
import { setResumeHrefParam } from '../../utils';
import { parseCaseUri, canResumeCase } from '../../utils/caseParseUtil';
import { ROUTE_APPLICATION_SUBMISSION_PAGE } from '../../utils/constants';

const getApplicants = (context, caseItemName, caseItemPersonalCustomerNumber, userName) => {
  const { customers: customerDetail } = context;
  return map(customerDetail, (applicant, index) => {
    return (
      <div className="applicant-details" key={`applicant-${index}`}>
        <GenericDescriptionList
          items={[
            {
              key: caseItemName,
              value: `${applicant.name['first_name']} ${applicant.name['last_name']} (${userName})`
            },
            {
              key: caseItemPersonalCustomerNumber,
              value: applicant['customer_number']
            }
          ]}
        />
      </div>
    );
  });
};

const ResumeDashBoardSection = () => {
  const { resumeCases } = useSelector(state => ({
    resumeCases: getResumeCases(state)
  }));

  const { userName } = useSelector(state => ({
    userName: state.dataCapture.toJS().username_password
      ? state.dataCapture.toJS().username_password.username
      : ''
  }));

  const dispatch = useDispatch();
  const resumeJourney = caseObj => {
    const {
      context: { accounts },
      id,
      uri
    } = caseObj;

    const caseUriObj = parseCaseUri(uri);

    if (uri && caseUriObj) {
      const productFromApi = first(accounts).product;
      const productName = productFromApi ? productFromApi.name : '';

      setResumeHrefParam(id, caseUriObj.caseType, productName);
      dispatch(
        setResumeConfigParam({
          caseId: id,
          productName,
          caseType: caseUriObj.caseType
        })
      );

      dispatch(redirectToPage(ROUTE_APPLICATION_SUBMISSION_PAGE));
    }
  };
  return (
    <Content>
      {({
        resumePortalPageTitle,
        resumePortalPageSubTitle,
        caseItemDetails,
        resumeButtonLabel,
        caseItemApplicants,
        caseItemCaseID,
        caseItemStartedOn,
        caseItemName,
        caseItemPersonalCustomerNumber
      }) => (
        <>
          <PageHeading>{resumePortalPageTitle}</PageHeading>
          <SubHeading>{resumePortalPageSubTitle}</SubHeading>
          {map(resumeCases, caseItem => {
            return (
              <BrandedPanel>
                <Inline.Justified
                  isNonWrapping
                  nodes={[
                    <SectionHeading>{caseItem.description}</SectionHeading>,
                    canResumeCase(caseItem.uri) && (
                      <ActionButton.Primary
                        labelText={resumeButtonLabel}
                        onClick={() => resumeJourney(caseItem)}
                      />
                    )
                  ]}
                />
                <SubsectionHeading>{caseItemDetails}</SubsectionHeading>
                <GenericDescriptionList
                  items={[
                    {
                      key: caseItemCaseID,
                      value: caseItem.id
                    },
                    {
                      key: caseItemStartedOn,
                      value: moment(caseItem.created_at).format(DATE_FORMAT)
                    }
                  ]}
                />
                <div className="u-margin-top-2">
                  <SubsectionHeading>{caseItemApplicants}</SubsectionHeading>
                  {getApplicants(
                    caseItem.context,
                    caseItemName,
                    caseItemPersonalCustomerNumber,
                    userName
                  )}
                </div>
              </BrandedPanel>
            );
          })}
        </>
      )}
    </Content>
  );
};
export default ResumeDashBoardSection;
